import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./error-styles.css";

export default function WrongPage() {
  return (
    <div className="error-page-div">
      <Helmet>
        <title>404 Page</title>
        <meta name="description" content="404 page" />
        <link rel="canonical" href="*" />
      </Helmet>
      <div className="error-page">
        <center>
          <h1 className="error-page-header">404 Page</h1>
          <p className="error-page-para">You seem to be lost</p>
          <Link className="error-page-homelink" to="/">
            Return to the Homepage
          </Link>
        </center>
      </div>
    </div>
  );
}
